module.exports = __webpack_public_path__ + "f59880ce9ab97a1f516da4f6acf77b30.png";